import React from 'react';
import { Box } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { generatePastelColor, generateSaturatedColor } from '../../Utils/colorUtils';

const TagChip = ({
  tagName,
  onClick,
  sx = {},
  showIcon = true,
  iconColor
}) => {
  const bgColor = generatePastelColor(tagName);
  const textColor = tagName.startsWith('#') ? '#5757b0' : generateSaturatedColor(tagName);

  return (
    <Box
      component="span"
      className="tag-chip"
      data-tag={tagName}
      onClick={onClick}
      sx={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '12px',
        fontFamily: 'monospace',
        fontSize: '0.75rem',
        marginRight: '6px',
        backgroundColor: bgColor,
        color: textColor,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        '&:hover': onClick ? {
          opacity: 0.8,
          transform: 'scale(1.05)'
        } : {},
        ...sx
      }}
    >
      {showIcon && (
        <LocalOfferIcon
          sx={{
            fontSize: '0.8rem',
            color: iconColor || textColor,
            marginRight: '4px',
            verticalAlign: 'middle'
          }}
        />
      )}
      {tagName}
    </Box>
  );
};

export default TagChip;